module.exports = __webpack_public_path__ + "static/media/cericon.a8886517.svg";